module.exports = __webpack_public_path__ + "static/media/silver.e44cce9e.webp";